let sb = require('@sb/util')
import store from '@sb/store'
import ListField from './ListField.js'

export default {
	props: ['form', 'ev'],

	data () {
		return {
			...store.bind(this, ['user']),
			rerender: false,
			showDropdownListType: false,
			formData: [],
		}
	},

	created () {
		let fields = sb.get(this.form, 'fields') || []
		this.formData = sb.map(fields, field => {
			let is_required = field.is_required || false

			var state = sb.parseJSON(field.state) || {}
			if (!is_required) is_required = state.require || false

			var userattr = sb.getUserAttr(this.user, field.name, state.type || 'text')
			return {
				name: field.name,
				items: field.items,
				value: sb.parseJSON(field.answer) || sb.parseJSON(field.default_answer) || userattr,
				is_required,
				label: field.title,
				type: field.input_type,
			}
		})
	},

	render () {
		var a = this.rerender
		if (sb.size(this.formData) === 0) return null
		let $fields = this.renderFields()

		let $submitbutton = null
		if (!this.form._submitted) {
			$submitbutton = (
				<div class="mt-2">
					<button vOn:click={this.submit} type="button" class="form-attachment--submit-btn">
						{this.$t('btn_submit_form_attachment')}
					</button>
				</div>
			)
		}
		// dont use <form /> , hit enter on this input cause page to reloate <form><input type="text"/></form>
		// see https://stackoverflow.com/questions/1370021/why-does-forms-with-single-input-field-submit-upon-pressing-enter-key-in-input
		return (
			<div class="form-attachment" vOn:click_stop={() => {}}>
				{this.$t(this.form.title) || this.$t('capture_lead_title')}

				{$fields}
				{$submitbutton}
			</div>
		)
	},

	methods: {
		focus () {
			if (store.isPreview) return
			if (sb.size(this.formData) === 0) return

			// focus the first un filled or last filled

			let $field
			if (this.isFormFilled()) {
				var keys = Object.keys(this.formData)
				var lastkey = keys[sb.size(keys) - 1]
				var lastfield = this.formData[lastkey]
				$field = this.$refs['field.' + lastfield.name]
			} else {
				var firstunfilledfield = this.firstUnfilledField()
				if (!firstunfilledfield) return
				$field = this.$refs['field.' + firstunfilledfield.name]
			}

			if ($field) $field.focus()
		},

		firstUnfilledField () {
			return sb.find(this.formData, field => field.value == null || field.value === '')
		},
		isFormFilled () {
			return !sb.find(this.formData, field => field.value == null || field.value === '')
		},

		renderFields () {
			if (sb.size(this.formData) === 0) return null
			let $fields = null

			$fields = sb.map(this.formData, (field, index) => {
				let $field = null
				if (field.answered) {
					this.form._submitted = true
				}
				var errclass = field.error ? 'input--error' : ''
				if (field.type === 'text') {
					if (this.form._submitted) {
						$field = (
							<div class="form-control--container">
								<input
									disabled
									ref={'field.' + field.name}
									vModel={this.formData[index].value}
									class={`form-control ${errclass}`}
									type="text"
								/>
								<i class="form-control--check"></i>
							</div>
						)
					} else {
						$field = (
							<input
								ref={'field.' + field.name}
								vModel={this.formData[index].value}
								class={`form-control ${errclass}`}
								type="text"
							/>
						)
					}
				} else if (field.type === 'number') {
					if (this.form._submitted) {
						$field = (
							<div class="form-control--container">
								<input
									disabled
									ref={'field.' + field.name}
									vModel={this.formData[index].value}
									class={`form-control ${errclass}`}
									type="number"
								/>
								<i class="form-control--check"></i>
							</div>
						)
					} else {
						$field = (
							<input
								ref={'field.' + field.name}
								vModel={this.formData[index].value}
								class={`form-control ${errclass}`}
								type="number"
							/>
						)
					}
				} else if (field.type === 'boolean') {
					$field = (
						<div class="checkbox">
							<input
								ref={'field.' + field.name}
								type="checkbox"
								id={'checkbox.' + this.ev.id + '.' + field.name}
								onChange={ev => (this.formData[index].value = ev.target.checked)}
								checked={field.value}
							/>
							<label class="checkbox--label" for={'checkbox.' + this.ev.id + '.' + field.name}>
								{field.label}
							</label>
							<div class="checkbox--check">
								<div></div>
							</div>
						</div>
					)
				// } else if (field.type === 'list') {
				// 	$field = sb.map(field.items, item => (
				// 		<div class="radio">
				// 			<input
				// 				type="radio"
				// 				id={'radio.' + this.ev.id + '.' + item}
				// 				vModel={this.formData[index].value}
				// 				value={item}
				// 			/>
				// 			<label
				// 				class="radio--label"
				// 				for={'radio.' + this.ev.id + '.' + item}
				// 				value={item}>
				// 				{item}
				// 			</label>
				// 			<div class="radio--check">
				// 				<div class="inside"></div>
				// 			</div>
				// 		</div>
				// 	))
				} else if (field.type === 'list') {
					this.formData[index].value = this.formData[index].value || []
					let selected = this.formData[index].value
					let items = sb.filter(sb.get(field, 'items', []), item => {
						return !this.formData[index].value.includes(item)
					})
					$field = (
						<ListField
							selected={selected}
							items={items}
							vOn:onAddItem={item => this.formData[index].value.push(item)}
							vOn:onRemoveItem={i => this.$delete(this.formData[index].value, i)} />
					)
				} else if (field.type === 'datetime') {
					$field = <input vModel={this.formData[index].value} class={`form-control ${errclass}`} type="date" />
				}

				let label = field.label
				if (field.name === 'fullname') {
					label = this.$t('fullname')
				} else if (field.name === 'emails') {
					label = this.$t('email')
				} else if (field.name === 'phones') {
					label = this.$t('phones')
				}

				return (
					<div>
						<p class="label mt-3">
							{label}
							{field.is_required ? <span class="ml-1 red">*</span> : ''}
						</p>
						{field.error ? <div class="form-control--valid-input--error">{field.error}</div> : ''}
						{$field}
					</div>
				)
			})
			return <div>{$fields}</div>
		},

		async submit () {
			var hasError = false
			sb.map(this.formData, field => {
				if (field.is_required && (field.value === undefined || field.value === '' || (sb.size(field.value) === 0 && Array.isArray(field.value)))) {
					field.error = this.$t('error_empty')
					hasError = true
				} else {
					field.error = ''
				}

				if (field.name === 'emails' && field.value) {
					if (!sb.isEmail(field.value)) {
						field.error = this.$t('error_email_invalid') // 'The email is not valid'
						hasError = true
					}
				}
			})

			this.rerender = !this.rerender
			if (hasError) return

			let user = {}
			// prepare data
			sb.map(this.formData, field => {
				var attr = { key: field.name }
				field.answered = new Date().getTime()
				if (field.type === 'number') {
					attr.number = parseInt(field.value)
					field.answer = sb.stringify(attr.number)
				}
				if (field.type === 'datetime') {
					attr.datetime = new Date(field.value).toISOString()
					field.answer = sb.stringify(attr.datetime)
				}
				if (field.type === 'list') {
					attr.list = field.value
					field.answer = sb.stringify(attr.list)
				}
				if (field.type === 'text' || field.type === 'boolean') {
					attr[field.type] = field.value
					field.answer = sb.stringify(field.value)
				}

				sb.setUserAttr(user, attr)
			})

			// TODO: if (this.form._type === 'ask_info_form')
			store.setUser(user)

			let message = {
				attachments: [
					{
						type: 'form_submit',
						form_submit: {
							state: '{"user_id":"' + store.user.id + '"}',
							form_message_id: sb.get(this.ev, 'id'),
							fields: this.formData,
						},
					},
				],
			}

			let convoKey = sb.convoKeyOfEv(this.ev)
			store.sendConvoEvent(convoKey, message)
			this.$emit('submit')
		},
	},
}
